import React from 'react';

/**
 * Truncated text that shows the full value in a native tooltip on hover.
 */
export default function TruncateText({
  children,
  text,
  className = '',
  as: Tag = 'p',
  empty = '—',
  ...rest
}) {
  const value = text != null ? text : children;
  const display = value === null || value === undefined || value === '' ? empty : String(value);
  const showTitle = display !== empty;

  return (
    <Tag
      className={`truncate ${className}`.trim()}
      title={showTitle ? display : undefined}
      {...rest}
    >
      {display}
    </Tag>
  );
}

/** Two-line member cell: username + email, both with full-value hover tooltips. */
export function TruncateMemberCell({
  username,
  email,
  usernameClassName = 'font-semibold text-slate-900 max-w-[140px]',
  emailClassName = 'text-[11px] text-slate-700 max-w-[160px]',
  onUsernameClick,
}) {
  const name = username || '—';

  return (
    <div className="min-w-0">
      {onUsernameClick ? (
        <button
          type="button"
          onClick={onUsernameClick}
          title={name !== '—' ? name : undefined}
          className={`truncate max-w-[140px] text-left hover:text-violet-600 hover:underline transition-colors ${usernameClassName}`}
        >
          {name}
        </button>
      ) : (
        <TruncateText text={username} className={usernameClassName} />
      )}
      <TruncateText text={email} className={emailClassName} />
    </div>
  );
}
